export const PERMISSIONS = {
  ANDROID: {},
  IOS: {},
};

export const RESULTS = {
  UNAVAILABLE: 'unavailable',
  BLOCKED: 'blocked',
  DENIED: 'denied',
  GRANTED: 'granted',
  LIMITED: 'limited',
};

export const check = () => Promise.resolve(RESULTS.GRANTED);
export const request = () => Promise.resolve(RESULTS.GRANTED);

export const requestMultiple = (permissions) =>
  Promise.resolve(
    Object.fromEntries((permissions || []).map((p) => [p, RESULTS.GRANTED]))
  );

export const checkMultiple = (permissions) =>
  Promise.resolve(
    Object.fromEntries((permissions || []).map((p) => [p, RESULTS.GRANTED]))
  );

export const checkNotifications = () =>
  Promise.resolve({ status: RESULTS.GRANTED, settings: {} });

export const requestNotifications = () =>
  Promise.resolve({ status: RESULTS.GRANTED, settings: {} });

export const openSettings = () => Promise.resolve();
export const openPhotoPicker = () => Promise.resolve();
